import React from "react";

type Props = {
    label?: string;
};

export default function TextArea(props: React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    const { label } = props;

    return (
        <>
            <label
                dangerouslySetInnerHTML={{
                    __html: label,
                }}
                htmlFor={props.id}
            />
            <textarea
                id={props.id}
                rows={4}
                placeholder={props.placeholder}
            />
        </>
    );
}